import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import { authenticatedFetch } from "../../utils/apiClient";

class MoveUserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newRowNum: "",
      newSeatNum: "",
      reason: "",
      error: "",
      isSubmitting: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleInputChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value, error: "" });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    const { newRowNum, newSeatNum, reason } = this.state;
    const { person } = this.props;

    // Validation
    if (!newRowNum || !newSeatNum) {
      this.setState({ error: "Rad og plass er påkrevd" });
      return;
    }

    if (parseInt(newRowNum, 10) === person.rowNum && parseInt(newSeatNum, 10) === person.seatNum) {
      this.setState({ error: "Ny plass kan ikke være samme som nåværende plass" });
      return;
    }

    if (!reason.trim()) {
      this.setState({ error: "Grunn for flytting er påkrevd" });
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      
      const moveData = {
        firstName: person.firstName,
        lastName: person.lastName,
        phone: person.phone,
        paid: person.paid,
        seatNum: person.seatNum,
        rowNum: person.rowNum,
        oldSeatNum: person.seatNum,
        oldRowNum: person.rowNum,
        newSeatNum: parseInt(newSeatNum, 10),
        newRowNum: parseInt(newRowNum, 10),
        reason: reason.trim(),
        UpdatedBy: updatedBy
      };

      const response = await authenticatedFetch(`/api/admin/moveuser/${person.code}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(moveData)
      });

      if (response.ok) {
        this.props.onMoveSuccess();
        this.handleClose();
      } else {
        this.setState({ 
          error: "Feil ved flytting av bruker. Sjekk at den nye plassen er ledig.",
          isSubmitting: false 
        });
      }
    } catch (err) {
      console.error("Error moving user:", err);
      this.setState({ 
        error: "Nettverksfeil ved flytting av bruker",
        isSubmitting: false 
      });
    }
  };

  handleClose() {
    this.setState({
      newRowNum: "",
      newSeatNum: "",
      reason: "",
      error: "",
      isSubmitting: false
    });
    this.props.onClose();
  }

  render() {
    const { show, person } = this.props;
    const { newRowNum, newSeatNum, reason, error, isSubmitting } = this.state;

    if (!show || !person) return null;

    return (
      <div className="modal" style={{ display: "block" }}>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                Flytt {person.firstName} {person.lastName}
              </h4>
              <button type="button" className="close" onClick={this.handleClose}>
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                <strong>Nåværende plass:</strong> Rad {person.rowNum}, Plass {person.seatNum}
              </p>
              
              <form onSubmit={this.handleSubmit}>
                <div className="form-group">
                  <label htmlFor="newRowNum">Ny rad:</label>
                  <input
                    type="number"
                    className="form-control"
                    id="newRowNum"
                    name="newRowNum"
                    value={newRowNum}
                    onChange={this.handleInputChange}
                    min="1"
                    max="50"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="newSeatNum">Ny plass:</label>
                  <input
                    type="number"
                    className="form-control"
                    id="newSeatNum"
                    name="newSeatNum"
                    value={newSeatNum}
                    onChange={this.handleInputChange}
                    min="1"
                    max="50"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="reason">Grunn for flytting:</label>
                  <textarea
                    className="form-control"
                    id="reason"
                    name="reason"
                    value={reason}
                    onChange={this.handleInputChange}
                    rows="3"
                    required
                    placeholder="Beskriv hvorfor brukeren flyttes..."
                  />
                </div>

                {error && (
                  <div className="alert alert-danger">
                    {error}
                  </div>
                )}
              </form>
            </div>
            <div className="modal-footer">
              <button 
              style={{cursor:'pointer'}}
                type="button" 
                className="btn btn-secondary" 
                onClick={this.handleClose}
                disabled={isSubmitting}
              >
                Avbryt
              </button>
              <button 
                style={{cursor:'pointer'}}
                type="button" 
                className="btn btn-primary" 
                onClick={this.handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Flytter..." : "Flytt bruker"}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAuth(MoveUserModal);


// WEBPACK FOOTER //
// ./src/Components/Admin/MoveUserModal.js